var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 34.5H38.25V51.375H42V32.625C42 31.5887 41.1613 30.75 40.125 30.75H28.875C27.8387 30.75 27 31.5887 27 32.625V51.375H30.75V34.5Z",
    fill: "#2AA7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.625 15.75H38.25V19.5H45.75V49.5H8.25V19.5H15.75V15.75H6.375C5.33869 15.75 4.5 16.5887 4.5 17.625V51.375C4.5 52.4113 5.33869 53.25 6.375 53.25H47.625C48.6613 53.25 49.5 52.4113 49.5 51.375V17.625C49.5 16.5887 48.6613 15.75 47.625 15.75Z",
    fill: "#2AA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75H4.5V12H15.75V8.25H2.625C1.58869 8.25 0.75 9.08869 0.75 10.125V17.625C0.75 18.6613 1.58869 19.5 2.625 19.5H15.75V15.75Z",
    fill: "#2AA7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.375 8.25H38.25V12H49.5V15.75H38.25V19.5H51.375C52.4113 19.5 53.25 18.6613 53.25 17.625V10.125C53.25 9.08869 52.4113 8.25 51.375 8.25Z",
    fill: "#2AA7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 27H15.75C14.7137 27 13.875 26.1613 13.875 25.125V2.625C13.875 1.58869 14.7137 0.75 15.75 0.75H38.25C39.2863 0.75 40.125 1.58869 40.125 2.625V25.125C40.125 26.1613 39.2863 27 38.25 27ZM17.625 23.25H36.375V4.5H17.625V23.25Z",
    fill: "#2AA7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 12H28.875V10.125C28.875 9.08869 28.0363 8.25 27 8.25C25.9637 8.25 25.125 9.08869 25.125 10.125V12H23.25C22.2137 12 21.375 12.8387 21.375 13.875C21.375 14.9113 22.2137 15.75 23.25 15.75H25.125V17.625C25.125 18.6613 25.9637 19.5 27 19.5C28.0363 19.5 28.875 18.6613 28.875 17.625V15.75H30.75C31.7863 15.75 32.625 14.9113 32.625 13.875C32.625 12.8387 31.7863 12 30.75 12Z",
    fill: "#2AA7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 42H13.875C12.8387 42 12 41.1613 12 40.125V36.375C12 33.2732 14.5232 30.75 17.625 30.75C20.7268 30.75 23.25 33.2732 23.25 36.375V40.125C23.25 41.1613 22.4113 42 21.375 42ZM15.75 38.25H19.5V36.375C19.5 35.3404 18.6596 34.5 17.625 34.5C16.5904 34.5 15.75 35.3404 15.75 36.375V38.25Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabs);
export default __webpack_public_path__ + "static/media/labs.9fd593fa4e15c790a240376a1768ef6b.svg";
export { ForwardRef as ReactComponent };